import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import ProjectFocus from './components/ProjectFocus';
import Services from './components/Services';
import Engagement from './components/Engagement';
import Metrics from './components/Metrics';
import Projects from './components/Projects';
import Packages from './components/Packages';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <ProjectFocus />
      <Services />
      <Engagement />
      {/* <Metrics /> */}
      <Projects />
      <Packages />
      <Footer />
    </div>
  );
}

export default App;